import { createRequest } from '../../Api';
import get from 'lodash/get';
import getCountryParam from '../../../Utils/getCountryParam';
export const RECEIVE_COUNTRY_LIST = 'RECEIVE_COUNTRY_LIST';
export const SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY';

export const receiveCountryList = (data) => ({
  type: RECEIVE_COUNTRY_LIST,
  data,
});

export const getCountryList = () => async (dispatch) => {
  const { request } = createRequest();
  const countryParam = getCountryParam();
  try {
    const response = await request(`/frontendapi/country/list`);
    const countryList = get(response, 'data', []);
    dispatch(receiveCountryList(countryList));
    if (countryParam) {
      dispatch(selectCountry(countryParam));
    }
  } catch (e) {
    console.log(e);
  }
};

export const selectCountry = (data) => (dispatch) => {
  const url = new URL(window.location);
  url.searchParams.set('_country', data);
  window.history.pushState({}, '', url.toString());

  return dispatch({
    type: SET_SELECTED_COUNTRY,
    data,
  });
};
